// Server-side launch-lock middleware.
// Composed AFTER requireSupabaseAuth. The private beta gate now only blocks
// public sign-up; existing signed-in users retain full access to server
// functions, so this middleware is a thin auth passthrough kept in place to
// preserve existing call sites.
import { createMiddleware } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

export const requireStaffWhileLocked = createMiddleware({ type: "function" })
  .middleware([requireSupabaseAuth])
  .server(async ({ next }) => next());
